/* eslint-disable import/prefer-default-export */

export const CONFIRM_CHANGED = 'CONFIRM_CHANGED';
export const DATA_TABLE_EL_CHANGED = 'DATA_TABLE_EL_CHANGED';
export const REFUND_CHANGED = 'REFUND_CHANGED';
export const ALL_ORDER_IDS_CHANGED = 'ALL_ORDER_IDS_CHANGED';
export const SUBMITTING_REFUND_CHANGED = 'SUBMITTING_REFUND_CHANGED';
export const CREATING_REFUND_CHANGED = 'CREATING_REFUND_CHANGED';
export const BUILDING_REFUND_CHANGED = 'BUILDING_REFUND_CHANGED';
